import { useEffect, useState } from "react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Switch } from "../../ui/switch";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { v4 as uuidv4 } from "uuid";

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow
} from "../../ui/table";

import { Label } from "../../ui/label";
import {
    Search,
    Plus,
    Edit,
    Trash2,
    Download,
    Globe,
    ExternalLink,
    Shield,
    Key,
    User,
    Loader2
} from "lucide-react";
import { useToast } from "../../../hooks/use-toast";
import { Role } from "../interfaces/CommonInterfaces";
import PublishComponent from "../PublishComponent";
import { myLocalStorage } from "../../StorageHelper";
import useUserStore from "../../../services/userStore";
import { createAuth, deleteURL, getWebUrls, publishURL, updateAuth, updateRecording } from "./Api/weburlapi";
import { Auth, WebUrlData, webURLLoadingState, WebUrlRecord } from "./interface";
import TenantLists from "../TenantLists";
import { getRolesList } from "../Endpoints/Api/EndpointApi";
import AddEditWebUrl from "./AddEditWebUrl";
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "../Endpoints/ConfirmationDialog";
import TenantWebUrlsTable from "../TenantWebURL/TenantWebUrlsTable";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { NGROK } from "../../../APIs";
import axios from "axios";
import { FaApple, FaWindows } from "react-icons/fa6";
import { formatDate } from "../formatTimeAgo";
import binaryApi from "../../../utils/binaryApi";

export default function WebUrlsTable() {
    const { toast } = useToast();
    const [selectedTenant, setSelectedTenant] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
    const [newUrl, setNewUrl] = useState("");
    const [newDescription, setNewDescription] = useState("");
    const tenantName = myLocalStorage.getItem("latestTenant")?.tenantName || "";
    const { role, email, userId, userRoleId, userRole } = useUserStore(
        (state) => state.user,
    );
    const [loadingRoles, setLoadingRoles] = useState(true);
    const [selectedWebUrl, setSelectedWebUrl] = useState<WebUrlRecord>();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [selectedAuth, setSelectedAuth] = useState<WebUrlRecord>();
    const [open, setOpen] = useState<boolean>(false);
    const [credentialsearch, setCredentialsearch] = useState<string>("");
    const [selectedCredential, setSelectedCredential] = useState<Auth>();
    const userData = useUserStore((state) => state.user);
    const [loadingWebUrlState, setLoadinWebUrlState] = useState<Record<string, webURLLoadingState>>({});
    const [loadingState, setLoadingState] = useState<Record<string, boolean>>({});

    let userAccess = userData.role;
    let loginemail = userData.email;

    const [roles, setRoles] = useState<Role[]>([]);
    const [mode, setMode] = useState<"add" | "edit">("add");

    const [webUrls, setWebUrls] = useState<WebUrlRecord[]>([]);
    const navigate = useNavigate();
    const access_token = myLocalStorage.getItem("access_token");


    const loginToUrl = async (selectedUser: Auth) => {

        let { authValutTags, email } = selectedUser;
        let randomUUID = uuidv4();
        let payload = {
            tokenpasskey: randomUUID,
            userTag: authValutTags,
            email: email,
            token: access_token,
            url: NGROK,
            executeURL: selectedAuth?.url,
            role: userAccess,
            duration: 0,
            tenantName: tenantName,
            webId: selectedAuth?.id,
            loginemail: loginemail,
            isRecordingOff: !selectedAuth?.recordingenabled,
        };
        const response = await axios
            .get(`${NGROK}/api/websites/save-web-url-click?uuid=${randomUUID}`)
            .then(async () => {
                await axios
                    .post("http://localhost:5051/start-automation", payload)
                    .then((data) => {




                    })
                    .catch((e) => {
                        console.log("Error {}", e);
                        const message = e?.response?.data?.message;
                        if (selectedAuth) {
                            setLoadinWebUrlState((prevState: any) => ({
                                ...prevState,
                                [selectedAuth.id]: {
                                    loading: false,
                                    message: "Connected"
                                }
                            }));
                        }

                        toast({
                            title: "WSWebApp not running",
                            description: message ||
                                "WSWebApp not running... Make sure that the zip is downloaded and WSWebApp is running",
                            variant: "destructive",
                        });
                    });
            })
            .catch((e) => {
                console.log("Error {}", e);
                const message = e?.response?.data?.message;
                if (selectedAuth) {
                    setLoadinWebUrlState((prevState: any) => ({
                        ...prevState,
                        [selectedAuth.id]: {
                            loading: false,
                            message: "Connected"
                        }
                    }));
                }
                toast({
                    title: "WSWebApp not running",
                    description: message ||
                        "WSWebApp not running... Make sure that the zip is downloaded and WSWebApp is running",
                    variant: "destructive",
                });

            });

        setTimeout(() => {
            if (selectedAuth) {
                setLoadinWebUrlState((prevState: any) => ({
                    ...prevState,
                    [selectedAuth.id]: {
                        loading: false,
                        message: "Connected"
                    }
                }));
            }
        }, 5000)


    };



    const handleWebURLClick = (url: WebUrlRecord) => {
        try {
            if (url)
                navigate(`/webUrls/webUrldetails/${url.id}`);

        } catch (e) {
            console.log(e)
        }
    };

    const getFaviconUrl = (url: string) => {
        try {
            const domain = new URL(url).hostname;
            return `https://www.google.com/s2/favicons?sz=64&domain=${domain}`;
        } catch {
            return undefined;
        }
    };

    const filteredUrls = webUrls.filter(url =>
        url.url.toLowerCase().includes(searchQuery.toLowerCase())
    ).sort((a, b) => b.id - a.id);
    const filteredCredentials = selectedAuth?.auth.filter(search => search.email.toLowerCase().includes(credentialsearch.toLowerCase()));

    const handlePublish = async (urlId: number, selectedRoles: string[]) => {
        let response = await publishURL(tenantName, urlId, selectedRoles);
        toast({
            title: "URL Published",
            description: selectedRoles.length > 0 ? `URL published to ${selectedRoles.length} role(s)` : "Unpublished from all roles"
        });
        if (response) fetchWebURLs(tenantName);
    };

    const handleRecordingChange = async (urlId: number, recording: boolean) => {
        let response = await updateRecording(tenantName, urlId);
        toast({
            title: recording ? "Recording Enabled" : "Recording Disabled",
            description: `Recording has been ${recording ? 'enabled' : 'disabled'} for this URL`
        });
        if (response) fetchWebURLs(tenantName);
    };

    const handleConnect = (url: WebUrlRecord) => {
        setSelectedAuth(url);
        setOpen(true)
    };

    const handleAddUrl = async (payload: WebUrlData) => {
        if (!payload.url.trim()) {
            toast({
                title: "Error",
                description: "URL is required",
                variant: "destructive"
            });
            return;
        }

        const domain = payload.url;

        let data = {
            url: domain,
            tenantName: tenantName,
            isManaged: false,
            auth: payload.credentials
        }
        try {
            const exists = webUrls.some(webUrl => webUrl.url === domain);
            if (!exists) {
                await createAuth(data);
                setNewUrl("");
                setNewDescription("");
                setIsAddDialogOpen(false);

                toast({
                    title: "URL Added",
                    description: `${domain} has been added successfully`
                });
                fetchWebURLs(tenantName)
            } else {
                toast({
                    title: "Error",
                    description: "URL already exists",
                    variant: "destructive"
                });
            }
        } catch (error) {
            toast({
                title: "Error",
                description: "Failed to add URL",
                variant: "destructive"
            });
        }

    };

    const handleEdit = async (payload: any) => {
        await updateAuth(payload, tenantName);
        setIsAddDialogOpen(false);
        toast({
            title: "Edit URL",
            description: payload.url.length > 0
                ? `Edited for ${payload.url}`
                : "Edited Web URL",
        });
        fetchWebURLs(tenantName)
    };

    const handleDelete = async (urlId: number) => {


        await deleteURL(urlId)

        const url = webUrls.find(u => u.id === urlId);
        setWebUrls(prev => prev.filter(u => u.id !== urlId));
        toast({
            title: "URL Deleted",
            description: `${url?.url} has been deleted successfully`
        });
        fetchWebURLs(tenantName)
    };


    const handleDownloadZip = async (type: string) => {
        toast({
            title: "Download Started",
            description: `Downloading ${type} zip file...`,
        });

        try {
            setLoadingState((prev: any) => ({
                ...prev,
                [type]: true,
            }));

            const response = await binaryApi.get(
                `${NGROK}/api/websites/download?os=${type}`,
                {
                    onDownloadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            const percent = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            console.log(`Progress: ${percent}%`);
                        }
                    },
                }
            );

            const blob = new Blob([response.data], { type: "application/zip" });

            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "WSWebApp.zip";
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Download failed", err);
            toast({
                title: "Download Failed",
                description: "Unable to download the file",
                variant: "destructive",
            });
        } finally {
            setLoadingState((prev: any) => ({
                ...prev,
                [type]: false,
            }));
        }
    };



    const fetchWebURLs = async (tenantName: string) => {
        const response = await getWebUrls(tenantName, email);
        setWebUrls(response)
    }
    const getRoles = async () => {
        setLoadingRoles(true);
        try {
            const response = await getRolesList(tenantName);
            if (response && response.length > 0) {
                const formattedRoles: Role[] = response
                    .map((role: { id: number; roleName: string }) => ({
                        id: String(role.id),
                        name: role.roleName,
                    }))
                    .filter(
                        (role: Role) =>
                            role.name !== "super-user" &&
                            role.name !== "unassigned-user"
                    );

                setRoles(formattedRoles);
            } else {
                setRoles([]);
            }
        } finally {
            setLoadingRoles(false);
        }
    };




    useEffect(() => {
        if (role !== "TENANT_USER") {
            getRoles()

        }
        fetchWebURLs(tenantName);

    }, [tenantName, email])



    return (
        <div className="min-h-screen bg-background flex flex-col">
            {/* Full-width Header */}
            <div className="bg-slate-50 dark:bg-slate-900/50 border-b px-8 py-6">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                        <Globe className="w-6 h-6 text-blue-600" />
                    </div>
                    <div className="flex-1">
                        <h1 className="text-3xl font-bold tracking-tight">Web URLs Management</h1>
                        <p className="text-base text-muted-foreground mt-1">Secure access management for web applications and  URLs</p>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="flex-1 px-8 py-5">

                <Card className="shadow-sm">
                    <CardHeader className="bg-white dark:bg-slate-800/50 border-b">
                        <div className="flex flex-col xl:flex-row gap-4 items-start xl:items-center justify-between">
                            {/* Left side controls */}
                            <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center">
                                <div className="flex items-center gap-3">
                                    <TenantLists onSelectorChange={(tenant: string) => {
                                        setSelectedTenant(tenant);

                                    }} isLabelNeeded={true} />
                                </div>

                                <div className="relative">
                                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                                    <Input
                                        placeholder="Search URLs by domain or name..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="pl-10 w-72 h-9 text-sm"
                                        data-testid="input-search"
                                    />
                                </div>
                            </div>

                            {/* Right side controls */}
                            <div className="flex flex-wrap items-center gap-3">
                                <div className="text-xs text-muted-foreground">
                                    {filteredUrls.length} {filteredUrls.length === 1 ? 'URL' : 'URLs'} found
                                </div>

                                <div className="flex items-center gap-2">
                                    <Button
                                        variant="outline"
                                        onClick={() => handleDownloadZip("mac")}
                                        className="gap-1.5 h-9 px-3"
                                        size="sm"
                                        data-testid="button-download-webapp"
                                        disabled={loadingState["mac"] || false}
                                    >
                                        <FaApple className="w-4 h-4" />
                                        Download Zip
                                        {loadingState["mac"] && <Loader2 className="w-4 h-4 text-white-600 dark:text-white-400 animate-spin" />}

                                    </Button>
                                    <Button
                                        variant="outline"
                                        onClick={() => handleDownloadZip("windows")}
                                        className="gap-1.5 h-9 px-3"
                                        size="sm"
                                        data-testid="button-download-extension"
                                        disabled={loadingState["windows"] || false}
                                    >
                                        <FaWindows className="w-4 h-4" />
                                        Download Zip
                                        {loadingState["windows"] && <Loader2 className="w-4 h-4 text-white-600 dark:text-white-400 animate-spin" />}

                                    </Button>
                                    {role !== "TENANT_USER" && <Button
                                        onClick={() => {
                                            setMode("add");
                                            setIsAddDialogOpen(true)
                                        }}
                                        className="gap-1.5 h-9 px-4"
                                        size="sm"
                                        data-testid="button-add-url"
                                    >
                                        <Plus className="w-4 h-4" />
                                        Add New URL
                                    </Button>}

                                </div>
                            </div>
                        </div>

                        {/* Info text */}
                        <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-950/30 rounded-lg border border-blue-200 dark:border-blue-800">
                            <p className="text-sm text-blue-800 dark:text-blue-200 flex items-start gap-2">
                                <Download className="w-4 h-4 mt-0.5 flex-shrink-0" />
                                <span>
                                    <strong>Setup Instructions:</strong> Ensure the downloaded zip files are installed and WSWebApp is running on the target machines where these URLs will be accessed. This enables secure credential management and session handling.
                                </span>
                            </p>
                        </div>
                    </CardHeader>


                    {role === "TENANT_USER" ?
                        <TenantWebUrlsTable webUrls={webUrls} onConnect={() => { }} refetchWebUrls={() => fetchWebURLs(tenantName)} searchQuery={searchQuery} /> :


                        <CardContent className="p-0">
                            {/* Enterprise URLs Table */}
                            <div className="rounded-b-lg overflow-hidden">
                                <Table>
                                    <TableHeader>
                                        <TableRow className="bg-slate-800 hover:bg-slate-800 dark:bg-slate-900 dark:hover:bg-slate-900 border-0">
                                            <TableHead className="text-white font-bold text-sm py-3 px-4">Web Application</TableHead>
                                            <TableHead className="text-white font-bold text-sm py-3 px-4">Role Management</TableHead>
                                            <TableHead className="text-white font-bold text-sm py-3 px-4 text-center">Recording</TableHead>
                                            <TableHead className="text-white font-bold text-sm py-3 px-4 text-center">Access</TableHead>
                                            <TableHead className="text-white font-bold text-sm py-3 px-4 text-center">Actions</TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {filteredUrls.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5} className="text-center py-12 ">
                                                    <div className="flex flex-col items-center gap-3">
                                                        <div className="w-12 h-12 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center">
                                                            <Globe className="w-6 h-6 text-slate-400" />
                                                        </div>
                                                        <div className="text-lg font-medium text-slate-500">
                                                            {searchQuery ? "No URLs match your search criteria" : "No web URLs have been configured"}
                                                        </div>
                                                        <div className="text-slate-400 text-center max-w-md text-sm">
                                                            {searchQuery
                                                                ? "Try adjusting your search terms or add a new URL"
                                                                : "Start by adding your first web application URL to enable secure access management"
                                                            }
                                                        </div>
                                                        {!searchQuery && (
                                                            <Button
                                                                onClick={() => setIsAddDialogOpen(true)}
                                                                className="gap-1.5 mt-1"
                                                                size="sm"
                                                            >
                                                                <Plus className="w-4 h-4" />
                                                                Add Your First URL
                                                            </Button>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            filteredUrls.map((url) => (
                                                <TableRow key={url.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 border-b transition-colors" data-testid={`row-url-${url.id}`}>
                                                    <TableCell className="py-3 px-4 " >
                                                        <div className="flex items-center gap-3">
                                                            <div className="w-10 h-10  from-blue-100 to-blue-50 dark:from-blue-900/20 dark:to-blue-800/10  flex items-center justify-center">
                                                                {getFaviconUrl(url.url) ? (
                                                                    <img
                                                                        src={getFaviconUrl(url.url)}
                                                                        alt="favicon"
                                                                        className="w-6 h-6 object-contain"
                                                                    />
                                                                ) : (
                                                                    <Globe className="w-6 h-6 text-blue-600" />
                                                                )}
                                                            </div>
                                                            <div className="flex-1">
                                                                <div className="font-semibold text-sm mb-1 cursor-pointer hover:underline" onClick={() => {
                                                                    handleWebURLClick(url)
                                                                    localStorage.setItem("selectedWebUrl", url.url);
                                                                }}>{url.url}</div>
                                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 text-xs text-muted-foreground">
                                                                    <div>Created: {formatDate(url.date)}</div>
                                                                    <div>By: {url.createdBy}</div>
                                                                    <div className="sm:col-span-2">Credentials: {url.auth.length || 0}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </TableCell>

                                                    <TableCell className="py-3 px-4">
                                                        <div className="space-y-2">
                                                            <PublishComponent
                                                                entityName={url.url}
                                                                entityType="url"
                                                                availableRoles={roles}
                                                                publishedRoles={url.publishedroleIds || []}
                                                                onPublish={(selectedRoles) => handlePublish(url.id, selectedRoles)}
                                                                buttonVariant="outline"
                                                                buttonSize="sm"
                                                            />

                                                        </div>
                                                    </TableCell>

                                                    <TableCell className="py-3 px-4">
                                                        <div className="flex items-center justify-center">
                                                            <Switch
                                                                checked={url.recordingenabled}
                                                                onCheckedChange={(checked) => handleRecordingChange(url.id, checked)}
                                                                data-testid={`switch-recording-${url.id}`}
                                                                className="scale-75"
                                                            />
                                                        </div>
                                                    </TableCell>

                                                    <TableCell className="py-3 px-4">
                                                        <div className="flex justify-center">
                                                            <Button
                                                                disabled={loadingWebUrlState[url.id]?.loading}
                                                                size="sm"
                                                                onClick={() => handleConnect(url)}
                                                                className="gap-1.5 px-3"
                                                                data-testid={`button-connect-${url.id}`}
                                                            >
                                                                <ExternalLink className="w-4 h-4" />
                                                                Connect
                                                                {loadingWebUrlState[url.id]?.loading && <Loader2 className="w-4 h-4 text-white-600 dark:text-white-400 animate-spin" />}

                                                            </Button>
                                                        </div>
                                                    </TableCell>

                                                    <TableCell className="py-3 px-4">
                                                        <div className="flex items-center justify-center gap-2">
                                                            <Button
                                                                variant="outline"
                                                                size="sm"
                                                                onClick={() => {
                                                                    setMode("edit");
                                                                    setSelectedWebUrl(url)
                                                                    setIsAddDialogOpen(true)

                                                                }}
                                                                className="gap-1.5 text-blue-600 hover:text-blue-700 border-blue-200 hover:border-blue-300 px-2 h-8"
                                                                data-testid={`button-edit-${url.id}`}
                                                            >
                                                                <Edit className="w-4 h-4" />
                                                                Edit
                                                            </Button>
                                                            <Button
                                                                variant="outline"
                                                                size="sm"
                                                                onClick={() => {
                                                                    setSelectedWebUrl(url);
                                                                    setShowDeleteConfirmation(true);
                                                                }}
                                                                className="gap-1.5 text-red-600 hover:text-red-700 border-red-200 hover:border-red-300 px-2 h-8"
                                                                data-testid={`button-delete-${url.id}`}
                                                            >
                                                                <Trash2 className="w-4 h-4" />
                                                                Delete
                                                            </Button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </div>
                        </CardContent>}
                </Card>
            </div>

            <AddEditWebUrl
                open={isAddDialogOpen}
                onOpenChange={setIsAddDialogOpen}
                mode={mode}
                onSave={(payload) => handleAddUrl(payload)}
                onEdit={(payload) => handleEdit(payload)}
                webUrl={selectedWebUrl && selectedWebUrl}
            />

            <ConfirmationDialog
                open={showDeleteConfirmation}
                onOpenChange={setShowDeleteConfirmation}
                title="Delete WebURL"
                description={`Are you sure, you want to delete this url - ${selectedWebUrl?.url}?`}
                confirmText="Delete"
                cancelText="Cancel"
                variant="destructive"
                onConfirm={() => {
                    if (selectedWebUrl)
                        handleDelete(selectedWebUrl?.id);
                }}
            />

            <Dialog open={open} onOpenChange={() => setOpen(false)} modal={true}>
                <DialogContent className="max-w-md">
                    <DialogHeader className="space-y-4">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center">
                                <Key className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                            </div>
                            <div>
                                <DialogTitle className="text-xl font-semibold">Select Credentials</DialogTitle>
                                <p className="text-sm text-muted-foreground mt-1">
                                    Choose the credentials to use for secure connection to
                                </p>
                            </div>
                        </div>
                    </DialogHeader>

                    <div className="space-y-4">
                        {/* Search Section */}
                        <Card>
                            <CardContent className="pt-6">
                                <div className="relative">
                                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                                    <Input
                                        placeholder="Search credentials by name, type, or description..."
                                        value={credentialsearch}
                                        onChange={(e) => setCredentialsearch(e.target.value)}
                                        className="pl-10 text-sm"
                                        data-testid="input-credential-search"
                                    />
                                </div>
                            </CardContent>
                        </Card>

                        {/* Credentials List */}
                        <Card>
                            <CardHeader>
                                <CardTitle className="text-lg flex items-center gap-2">
                                    <Shield className="w-5 h-5" />
                                    Available Credentials ({selectedAuth?.auth.length || 0})
                                </CardTitle>
                            </CardHeader>
                            <CardContent>
                                <div className="space-y-3 max-h-80 overflow-y-auto">
                                    {filteredCredentials?.map((credential) => (
                                        <div
                                            key={credential.id}
                                            className="flex cursor-pointer group transition-all duration-200 border rounded-lg hover-elevate"
                                            onClick={() => setSelectedCredential(credential)}
                                            data-testid={`credential-${credential.id}`}
                                        >
                                            {/* Side marker */}
                                            <div
                                                className={`w-1 rounded-l-lg ${selectedCredential?.id === credential.id ? "bg-blue-500" : "bg-transparent"
                                                    }`}
                                            ></div>

                                            <div className="p-4 flex-1">
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center gap-3">
                                                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 flex items-center justify-center group-hover:scale-105 transition-transform">
                                                            <User className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                                                        </div>
                                                        <div>
                                                            <div className="font-medium text-sm">{credential.email}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>

                                {filteredCredentials?.length === 0 && (
                                    <div className="text-center py-8">
                                        <Search className="w-8 h-8 text-muted-foreground mx-auto mb-3" />
                                        <p className="text-sm text-muted-foreground">
                                            No credentials found matching your search.
                                        </p>
                                        <p className="text-xs text-muted-foreground mt-1">
                                            Try adjusting your search criteria.
                                        </p>
                                    </div>
                                )}
                            </CardContent>
                        </Card>

                        {/* Submit and Cancel Buttons */}
                        <div className="flex justify-end gap-3 pt-4">
                            <Button variant="outline" onClick={() => setOpen(false)} data-testid="button-cancel" className="px-6">
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    if (selectedCredential)
                                        loginToUrl(selectedCredential)
                                    setOpen(false)
                                    setLoadinWebUrlState((prevState: any) => ({
                                        ...prevState,
                                        [selectedAuth?.id ?? ""]: {
                                            loading: true,
                                            message: "Connecting... Please wait."
                                        }
                                    }));

                                }}
                                disabled={!selectedCredential}
                                data-testid="button-submit"
                                className="px-6"
                            >
                                Submit
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>

        </div>
    );
}